import 'hammerjs';
import { BrowserModule } from '@angular/platform-browser';
import { ErrorHandler, NgModule, LOCALE_ID} from '@angular/core';
import { IonicApp, IonicErrorHandler, IonicModule } from 'ionic-angular';
import { HttpClientModule } from '@angular/common/http';
import { HttpModule } from '@angular/http';

import { MyApp } from './app.component';

// Plugins
import * as ionicGalleryModal from 'ionic-gallery-modal';
import { HAMMER_GESTURE_CONFIG } from '@angular/platform-browser';
import { IonicStorageModule } from '@ionic/storage';
import { CalendarModule } from 'ion2-calendar';
import {registerLocaleData} from '@angular/common';
import localeEs from '@angular/common/locales/es';

//import { far } from '@fortawesome/free-regular-svg-icons';
//import { fab } from '@fortawesome/free-brands-svg-icons';


// Providers
import { GlobalVars } from '../providers/global-vars/globalVars';
import { ApiServiceProvider } from '../providers/api-service/api-service';
import { NotificationsProvider } from './../providers/notifications/notifications';
import { CommonProvider } from '../providers/common/common';

registerLocaleData(localeEs);

@NgModule({
  declarations: [
    MyApp, 
  ],
  imports: [
    BrowserModule,
    IonicModule.forRoot(MyApp),
    HttpModule,
    HttpClientModule,
    ionicGalleryModal.GalleryModalModule,
    IonicStorageModule.forRoot(),
    CalendarModule,
    /* .forRoot({
      doneLabel: 'Save',
      closeIcon: true
    })
    */
  ],
  bootstrap: [IonicApp],
  entryComponents: [
    MyApp,
  ],
  providers: [
    GlobalVars,
    ApiServiceProvider,
    {
      provide: ErrorHandler, 
      useClass: IonicErrorHandler
    },
    {
      provide: HAMMER_GESTURE_CONFIG,
      useClass: ionicGalleryModal.GalleryModalHammerConfig,
    },
    NotificationsProvider,
    CommonProvider,
    {
      provide: LOCALE_ID, 
      useValue: "es" // -ES
    }
  ]
})
export class AppModule {}



// WEBPACK FOOTER //
// ./src/app/app.module.ts